import React from 'react'
import styled from 'styled-components'
import { SectionTitles, Container } from '../home/styles'

const SubHeading = styled.h3`
  margin-bottom: -2rem;
`

const faqs = [
  {
    q: 'Is this for me?',
    a: 'If you’re a marketer or doing marketing, and would like to or already use Quora for that job, yes.'
  },
  {
    q: 'Is it a printed book?',
    a: 'Nope'
  },
  {
    q: 'Oh, it’s only a short PDF. So you just want my email.',
    a: 'You’re not wrong. I’m a marketer too, and I do want your email. But I won’t spam you, and you’ll get a pretty good book about Quora Marketing. I even offer a 100% money back guarantee. 🙃'
  },
  {
    q: 'Why do you write this?',
    a: 'I read hundreds of articles on Quora Marketing. Even after reading 50 or so, there were still things I didn’t know. Time to put that knowledge into a proper format. Oh, and I want to market Find Better Questions with it. (Don’t worry, there’s only one page or two about it.)'
  },
  {
    q: 'This isn’t the first book on Quora Marketing',
    a: 'Yes'
  },
  {
    q: 'Will I learn about Quora ads?',
    a: 'No. This is about answering questions on Quora.'
  },
]

export { faqs }

export default class FAQ extends React.Component {
  render() {
    return (
      <Container>
        <SectionTitles>
          <h2>Frequent Questions</h2>
        </SectionTitles>
        {faqs.map(set => {
          switch(set.type) {
            case('space'): return (<p key={set.type}></p>)
            case('heading'): return (<SubHeading key={set.heading}>{set.heading}</SubHeading>)
            default: return (
              <div key={set.q}>
                <h4>{set.q}</h4>
                <p>{set.a}</p>
              </div>
            )
          }
        })}
        <div>
          <h3>Still have questions?</h3>
          Contact me at contact@findbetterquestions.com
        </div>
      </Container>
    )
  }
}
